export default "/images/6904526a2288f30ea976c54a06eaf440.avif";